export default {
    img: {
        confirm: {
            refresh: {
                query: "Sollen die Bilder aktualisiert werden?",
                text : "Bei dieser Aktion werden die Bilder aus dem Bildarchiv erneut eingelesen und für die Ansicht in diesem Dialog aufbereitet. Dies kann mehrer Miniten Zeit in Anspruch nehmen."
            },
            initialize: {
                title: "Bilder aus dem Archiv müssen aufbereitet werden",
                text : "Mit EINPLANEN werden die Bilder der Anlage aus dem Archiv für die weitere Verwendung vorbereitet. Dies kann mehrere Minuten in Anspruch nehmen und erfolgt im Hintergrund.<b><br><br>Soll die Einpanung zur Aufbereitung der Bilder nun durchgeführt werden?</b>"
            },
            scheduled: {
                title: "Bilder aus dem Archiv werden aufbereitet",
                text : "Die Bilder aus dem Archiv werden aktuell aufgereitet. Dies kann mehrere Minuten in Anspruch nehmen und erfolgt im Hintergrund. Mit dem LM4 kann inzwischen weiter gearbeitet werden."
            },
            stamp: {
                query: "Dokument mit einem Stempel versehen?",
                text : "Mit JA wird eine neue Version dieses Dokuments mit dem in den Benutzerdaten hinterlegten PDF Stempel erstellt. Das bisherige Dokument wird nicht verändert."
            },
            reset: {
                title: "Bilder für die Anlage zurücksetzen",
                text : "Mit <b>JA</b> werden die Bilder der Anlage werden gelöscht. Anschliessend können sie Bilder erneut wieder aus dem Bildarchiv importiert werden. Sollen die Bildewr nun gelsöcht werden?"
            },
        },
        info: {
            imageroot: {
                title: "Verzeichnis in Bildarchiv nicht gesetzt",
                text : "Das Verzeichnis im Bildarchiv, in dem die Bilder der Anlage enthalten sind, wurde noch nicht festgelegt. Dieses Verzeichnis kann in den Stammdaten zu der Anlage im Reiter EINSTELLUNGEN festgelegt werden."
            }
        },

        archive: {
            notexist: {
                title: "Archiv ungültig",
                message: "Das Verzeichnis <br><p style='margin-top: 10px'><span style='color:red'>{0}</span></p> mit den Bildern zu der Anlage existiert nicht oder kann nicht gelesen werden."
            }
        },

        unit: {
            scheduled: "Die Anlage ist bereits eingeplant",
            notexists: "Die Anlage wurde nicht gefunden."
        },

        root: {
            empty: "Das Verzeichnis darf nicht leer sein.",
            notexists: "Das Verzeichnis existiert nicht im Bildarchiv."
        },

        folder: {
            create: {
                title: "Ordner anlegen",
                name : "Name des Ordners",
                store: "Anlegen",
                action: "Ordner anlegen",
                empty: "Zu dieser Anlage gibt es noch keine Bilder.",
                noimages: "In diesem Ordner sind noch keine Bilder."
            },
            image: {
                category: {
                    lgs: "LiftGuardian",
                    book: "Prüfbuch",
                    image: "Bilder aus Begehung"
                }
            }
        },

        upload: {
            title : "Bilder hochladen",
            action: "Bilder hochladen",
            store : "Hochladen",
            folder: "Ordner",
            select: "Bilder oder PDF auswählen (max. 10 MB je Datei)",
            toolarge   : "Datei zu groß",
            unsupported: "Dateityp nicht unterstützt",
            timeout    : "Zeitüberschreitung",
            state: {
                WAITING    : "Wartet",
                UPLOADING  : "Wird hochgeladen",
                IN_PROGRESS: "Wird verarbeitet",
                DONE       : "Fertig",
                FAILED     : "Fehler"
            }
        },

        download: {
            action: "Herunterladen",
            done  : "Die ZIP Datei wurde im Download Verzeichis abgelegt",
            failed: "Der Download ist fehlgeschlagen"
        }
    },
}